// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__Z6XrX","modalFooterButton":"ModalNotes_modalFooterButton__2-qc7"};